import { MDXRemote } from 'next-mdx-remote';
import dynamic from 'next/dynamic';

import DocLayout from 'components/layouts/DocLayout';
import MdTextStack from 'components/mdxComponents/PageTextStack/PageTextStack';
import { mdxComponents } from 'components/mdxComponents/docMdx';
import { ApiMdxPageProps } from 'types/pages';

const VersioningWarning = dynamic(() => import('molecules/VersioningWarning'));

const ApiMdxPage: React.FC<ApiMdxPageProps> = ({
  seo,
  versions,
  config,
  isLatestVersion,
  mdxContent,
  repoUrl,
}) => {
  const isCoVeV1 = config.azureId === 'connected-vehicle-c3-v1';

  return (
    <DocLayout seo={seo} repoUrl={repoUrl}>
      <MdTextStack>
        {!isLatestVersion && (
          <VersioningWarning
            versions={versions}
            deprecationDate={isCoVeV1 ? 'April 30, 2024' : undefined}
          />
        )}
        <MDXRemote {...mdxContent} components={mdxComponents} />
      </MdTextStack>
    </DocLayout>
  );
};

export default ApiMdxPage;
